import { render } from "./DividaCreate.vue?vue&type=template&id=95c577e8&scoped=true"
import script from "./DividaCreate.vue?vue&type=script&lang=js"
export * from "./DividaCreate.vue?vue&type=script&lang=js"

import "./DividaCreate.vue?vue&type=style&index=0&id=95c577e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c577e8"]])

export default __exports__